export const MEDIA_SMALL = 576;
export const MEDIA_MEDIUM = 768;
export const MEDIA_LARGE = 992;

// Based on libs/ui/publish/src/components/utils/media.tsx
export const BREAKPOINTS = {
  XXS: 384, // mobile,
  XS: 576, // tablet
  SM: 768, // phablet
  MD: 992, // desktop
  LG: 1024, // navigationBreakpoint
  XL: 1200, // normal
  XXL: 1440,
  XXXL: 1500, // giant
} as const;
